import React from "react"
import { useNavigate, useParams, useLocation } from "react-router-dom"

/**
 * withRouter HOC for React Router v6
 * Provides navigation, params, and location to class components
 */
export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const navigate = useNavigate()
    const params = useParams()
    const location = useLocation()

    // Create a history-like object for backwards compatibility
    const history = {
      push: (path, state) => navigate(path, { state }),
      replace: (path, state) => navigate(path, { replace: true, state }),
      go: (n) => navigate(n),
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
      location,
    }

    // Create a match-like object for backwards compatibility
    const match = {
      params,
      path: location.pathname,
      url: location.pathname,
    }

    return (
      <Component
        {...props}
        navigate={navigate}
        params={params}
        location={location}
        history={history}
        match={match}
      />
    )
  }

  return ComponentWithRouterProp
}

export default withRouter
